import { Button, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { RoutingRulesFormStepName } from '../../types';
import { useRoutingRuleFormStepContext } from '../../contexts';
import { stepOrder } from '../../constants';

interface RoutingRuleFormFooterProps {
    submit: () => Promise<void>;
    onStepChange: (step: RoutingRulesFormStepName) => void;
    onCancel: () => void;
    isEditing: boolean;
    isPending: boolean;
}

const handleGoBack = (
    currentStep: RoutingRulesFormStepName,
    setCurrentStep: (step: RoutingRulesFormStepName) => void
) => {
    const currentIndex = stepOrder.indexOf(currentStep);
    const previousStep = stepOrder[currentIndex - 1];
    if (currentIndex > 0) {
        setCurrentStep(previousStep);
    }
};

const getButtonText = (currentStep: RoutingRulesFormStepName, isEditing: boolean) => {
    if (currentStep === RoutingRulesFormStepName.Summary && isEditing) {
        return lt(TextKey.RoutingRulesFormUpdateButtonText);
    }
    if (currentStep === RoutingRulesFormStepName.Summary) {
        return lt(TextKey.Save);
    }
    return lt(TextKey.Next);
};

export const RoutingRuleFormFooter = ({
    submit,
    onStepChange,
    onCancel,
    isEditing,
    isPending,
}: RoutingRuleFormFooterProps) => {
    const { currentStep } = useRoutingRuleFormStepContext();

    const handleSubmit = async () => {
        await submit();
    };

    return (
        <>
            <Button variant="tertiary" type="button" size="medium" onClick={onCancel}>
                {lt(TextKey.Cancel)}
            </Button>
            <Stack spacing="200">
                {currentStep !== RoutingRulesFormStepName.Timing && (
                    <Button
                        variant="secondary"
                        type="submit"
                        size="medium"
                        onClick={() => {
                            handleGoBack(currentStep, onStepChange);
                        }}
                    >
                        {lt(TextKey.GoBack)}
                    </Button>
                )}
                <Button variant="primary" type="submit" size="medium" onClick={handleSubmit} disabled={isPending}>
                    {getButtonText(currentStep, isEditing)}
                </Button>
            </Stack>
        </>
    );
};
